const $ = require('jquery');

/*******************************************
 * 
 * animeScript
 * ページや要素ごとの具体的なアニメの記述
 * 
********************************************/

$(function(){

'use strict';

var isDesktopWide = deviceObserver.isDesktopWide;
var isDesktop = deviceObserver.isDesktop;
var isTablet = deviceObserver.isTablet;
var isMobile = deviceObserver.isMobile;
var isMobileSE = deviceObserver.isMobileSE;

//setAnimation( _elm, _trigger, _beforeTween, _afterTween, _params);

window.animeScript = function(){

/*******************************************
 * 
 * top
 * 
********************************************/

(function() {

    if($('body.page-top').length){
        if( isDesktopWide || isDesktop || isTablet ){
            $('.top-Mainvisual').each(function(index, parentTile){
                $(this).find('.top-Mainvisual__bg').each(function(){
                    setAnimation(this, parentTile, { y:-200, delay:0 }, {});
                });
                $(this).find('.top-Mainvisual__text').children().each(function(index, elm){
                    setAnimation(this, parentTile, { y:100, delay:0.3*(index+1) }, {});
                });
                $(this).find('.top-Mainvisual__visual').each(function(){
                    setAnimation(this, parentTile, { delay:0, duration:6 }, {});
                });
            });
            $('.top-Tile').each(function(index, parentTile){
                $(this).find('.top-Tile__visual').each(function(){
                    setAnimation(this, parentTile, { y:50, delay:0 }, {});
                });
                $(this).find('.top-Tile__body').children().each(function(index, elm){
                    setAnimation(this, parentTile, { y:100, delay:0.1+0.2*(index+1) }, {});
                });
            });
        }
    }

})();

/*******************************************
 * 
 * about
 * 
********************************************/

if($('body.page-about').length){
    if( isDesktopWide || isDesktop || isTablet ){
        $('.about-VisualTile').each(function(index, parentTile){
            $(this).find('.about-VisualTile__visual').each(function(){
                setAnimation(this, parentTile, { x:-100, }, {});
            });
            $(this).find('.about-VisualTile__bg').each(function(){
                setAnimation(this, parentTile, { x:100, delay:0.6 }, {});
            });
            $(this).find('.about-VisualTile__body').each(function(){
                setAnimation(this, parentTile, { x:100, delay:0.6 }, {});
            });
        });
        $('.about-ContentTile--1').each(function(index, parentTile){
            $(this).find('.about-ContentTile__baloon').each(function(){
                setAnimation(this, parentTile, { y:50, }, {});
            });
            $(this).find('.about-ContentTile__quote').each(function(){
                setAnimation(this, parentTile, { duration:3 }, {});
            });
        });
    }
}

/*******************************************
 * 
 * visit
 * 
********************************************/

if($('body.page-visit').length){
    if( isDesktopWide || isDesktop || isTablet ){
        $('.visit-PhotoItem').each(function(index, parentTile){
            $(this).find('.visit-PhotoItem__photo').each(function(index, elm){
                setAnimation(this, parentTile, { duration:5 }, {});
            });
        });
    }
}

/*******************************************
 * 
 * statistics
 * 
********************************************/

if($('body.page-statistics').length){
    if( isDesktopWide || isDesktop || isTablet ){
        var elm_num = $('.statistics-Tile').length;
        $('.statistics-Tile').each(function(index, parentTile){
            var thisoffset = '+=0';
            if(index==(elm_num-1)){
                //最後の要素
                var thisoffset = '-=440';
            }
            $(this).find('.statistics-Tile__visual').each(function(){
                setAnimation(this, parentTile, { y:50, duration:3 }, {offset: thisoffset});
            });
            $(this).find('.statistics-NumberBlock').each(function(){
                $(this).find('[data-count-time]').each(function(index, elm){
                    var countTime = $(this).attr('data-count-time');
                    setAnimation(this, parentTile, {duration:5}, {offset: thisoffset}, function(){countup(elm, countTime)});
                });
            });
        });
    }
}
function countup(elm, countTime){
    if(!$(elm).hasClass('is-animated')){
        $(elm).addClass('is-animated');

        var constNum = Number( $(elm).html() ); //数字取得
        
        var timer = setInterval(function(){
            var val = Math.floor(10 * Math.random());
            $(elm).html( val );
        })

        setTimeout( function(){
            clearInterval(timer);
            $(elm).html(constNum);
        }, 1000 + Number(countTime), elm, constNum, timer)

    }
}

/*******************************************
 * 
 * faq
 * 
********************************************/

if($('body.page-faq').length){
    if( isDesktopWide || isDesktop || isTablet ){
        $('.faq-Tile').each(function(index, parentTile){
            $(this).find('.faq-Tile__faqItems').children().each(function(index, elm){
                setAnimation(this, parentTile, { x:50, delay:0.2*(index) }, {});
            });
        });
    }
}

/*******************************************
 * 
 * recruit
 * 
********************************************/

if($('body.page-recruit').length){
    if( isDesktopWide || isDesktop || isTablet ){
        $('.TablePlate').each(function(index, parentTile){
            setAnimation(this, parentTile, { y:50, }, {});
        });
    }
}

/*******************************************
 * 
 * voiceArchive
 * 
********************************************/

if($('body.page-voiceArchive').length){
    if( isDesktopWide || isDesktop || isTablet ){
        $('.voice-ArchiveTile').each(function(index, parentTile){
            $(this).find('.voice-ArchiveItems__item').each(function(index, elm){
                setAnimation(this, parentTile, { y:50, delay:0.2*(index) }, {});
            });
        });
    }
}

/*******************************************
 * 
 * voiceInterviewSingle
 * 
********************************************/

if($('body.page-voiceInterviewSingle').length){
    if( isDesktopWide || isDesktop || isTablet ){
        $('.voice-interview-TopTile').each(function(index, parentTile){
            $(this).find('.voice-interview-TopTile__visual').each(function(){
                setAnimation(this, parentTile, { x:-100, }, {});
            });
            $(this).find('.voice-interview-TopTile__bg').each(function(){
                setAnimation(this, parentTile, { x:100, delay:0.6 }, {});
            });
            $(this).find('.voice-interview-TopTile__body').each(function(){
                setAnimation(this, parentTile, { x:100, delay:0.6 }, {});
            });
            $(this).find('.voice-interview-TopTile__pict').each(function(){
                setAnimation(this, parentTile, { delay:0.6 }, {});
            });
        });
        $('.voice-interview-PhotoTile').each(function(index, parentTile){
            setAnimation(this, parentTile, { duration:3 }, {});
        });
        $('.voice-interview-MessageTile').each(function(index, parentTile){
            $(this).find('.voice-interview-MessageTile__image').each(function(){
                setAnimation(this, parentTile, { y:50, }, {});
            });
        });
    }
}

/*******************************************
 * 
 * voiceCrosstalkSingle
 * 
********************************************/

if($('body.page-voiceCrosstalkSingle').length){
    if( isDesktopWide || isDesktop || isTablet ){
        $('.voice-crosstalk-TopTile').each(function(index, parentTile){
            $(this).find('.voice-crosstalk-TopTile__visual').each(function(){
                setAnimation(this, parentTile, { x:-100, }, {});
            });
            $(this).find('.voice-crosstalk-TopTile__bg').each(function(){
                setAnimation(this, parentTile, { x:100, delay:0.6 }, {});
            });
            $(this).find('.voice-crosstalk-TopTile__body').each(function(){
                setAnimation(this, parentTile, { x:100, delay:0.6 }, {});
            });
            $(this).find('.voice-crosstalk-TopTile__pict').each(function(){
                setAnimation(this, parentTile, { delay:0.6 }, {});
            });
        });
        $('.voice-crosstalk-PhotoTile').each(function(index, parentTile){
            setAnimation(this, parentTile, { duration:3 }, {});
        });
        $('.voice-crosstalk-MessageTile').each(function(index, parentTile){
            $(this).find('.voice-crosstalk-MessageTile__image').each(function(){
                setAnimation(this, parentTile, { y:50, }, {});
            });
        });
    }
}

/*******************************************
********************************************/

}

});